import { SvgIcon, SvgIconProps } from '@mui/material';

const NewspaperFilled = ({ fill, fillOpacity, sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      data-testid="NewspaperFilledIcon"
      sx={{
        fill: fill,
        fillOpacity: fillOpacity ?? 1,
        ...sx
      }}
    >
      <path d="M21 2C22.1045 2.00006 23 2.89547 23 4V17C23 19.7614 20.7614 21.9999 18 22H4C2.34315 22 1 20.6569 1 19V8C1 6.89517 1.8959 6.00014 3 6H5V4C5 2.89543 5.89543 2 7 2H21ZM3 19C3 19.5523 3.44772 20 4 20C4.55228 20 5 19.5523 5 19V8H3V19ZM10 16C9.44772 16 9 16.4477 9 17C9 17.5523 9.44772 18 10 18H18C18.5523 18 19 17.5523 19 17C19 16.4477 18.5523 16 18 16H10ZM10 12C9.44772 12 9 12.4477 9 13C9 13.5523 9.44772 14 10 14H18C18.5523 14 19 13.5523 19 13C19 12.4477 18.5523 12 18 12H10ZM10 6C9.44772 6 9 6.44772 9 7V9C9 9.55228 9.44772 10 10 10H12C12.5523 10 13 9.55228 13 9V7C13 6.44772 12.5523 6 12 6H10ZM16 8C15.4477 8 15 8.44772 15 9C15 9.55228 15.4477 10 16 10H18C18.5523 10 19 9.55228 19 9C19 8.44772 18.5523 8 18 8H16Z" />
    </SvgIcon>
  );
};

export default NewspaperFilled;
